import { render, staticRenderFns } from "./BloquearPlazasRegionAnexa.vue?vue&type=template&id=18550cba"
import script from "./BloquearPlazasRegionAnexa.vue?vue&type=script&lang=js"
export * from "./BloquearPlazasRegionAnexa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports